import { makeEntityScaffold } from '@classpass/saga-tools';
import _isEmpty from 'lodash/isEmpty';
import _pick from 'lodash/pick';
import URLS from 'constants/urls';
import { transformKeysToCamelCase, transformKeysToSnakeCase } from 'helpers/core';
import { VENUE_FEATURE_PROBE_HTTP_CONFIG } from 'helpers/session-auth-http';

const convertBlobToBase64 = blob =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      if (reader.result) {
        resolve(reader.result);
      } else {
        reject(new Error('Failed converting to base64'));
      }
    };
    reader.readAsDataURL(blob);
  });

const prepareInstructorPicture = instructorData => {
  const { picture, ...restInstructor } = instructorData;

  if (!picture || !picture.length) {
    return Promise.resolve(restInstructor);
  }

  return convertBlobToBase64(picture[0]).then(pictureData => {
    const separatorIndex = pictureData.indexOf(',');
    return {
      ...instructorData,
      picture: pictureData.substr(separatorIndex + 1),
    };
  });
};

const prepareInstructorData = instructorData => {
  const allowedFields = [
    'active',
    'bio',
    'certifications',
    'email',
    'firstName',
    'lastName',
    'phone',
    'picture',
    'socialHandles',
    'venueIds',
  ];
  return Promise.resolve(instructorData)
    .then(prepareInstructorPicture)
    .then(instructor => _pick(instructor, allowedFields))
    .then(transformKeysToSnakeCase);
};

const get = (httpClient, venueId, instructorId) =>
  httpClient
    .get(URLS.instructors.instructor(venueId, instructorId), VENUE_FEATURE_PROBE_HTTP_CONFIG)
    .then(response => transformKeysToCamelCase(response.data))
    .then(response => Object.assign(response, { reviews: [] }));

const put = (httpClient, venueId, instructorData, instructorId) => {
  const endpoint = URLS.instructors.edit(venueId, instructorId);
  return Promise.resolve(instructorData)
    .then(prepareInstructorData)
    .then(instructor => httpClient.put(endpoint, instructor, VENUE_FEATURE_PROBE_HTTP_CONFIG))
    .then(response => response.data)
    .then(transformKeysToCamelCase);
};

const post = (httpClient, venueId, instructorData) => {
  const endpoint = URLS.instructors.add(venueId);
  return Promise.resolve(instructorData)
    .then(prepareInstructorData)
    .then(instructor => httpClient.post(endpoint, instructor, VENUE_FEATURE_PROBE_HTTP_CONFIG))
    .then(response => response.data)
    .then(transformKeysToCamelCase);
};

const handler = ({ httpClient }, venueId, instructorId, instructor) => {
  if (!_isEmpty(instructor)) {
    if (instructor.removed) {
      // Soft delete: set active to false using PUT request
      return put(httpClient, venueId, { active: false }, instructorId);
    }
    if (instructorId) {
      return put(httpClient, venueId, instructor, instructorId);
    }
    return post(httpClient, venueId, instructor);
  }
  return get(httpClient, venueId, instructorId);
};

export default makeEntityScaffold('SAGA.API.FETCH_INSTRUCTOR', handler, { defaultKey: 2 });
